import LeafletNavigationView from './leaflet_navigation_view'
import LeafletView from './leaflet_view'
import Scene from './scene'

// SceneView 全体を管理する view model クラス
// ドラッグやダブルクリックなどイベントのアサインや他の view model へのレンダリングの委譲を行う
class SceneView {
  static register(element) {
    return new SceneView(element)
  }

  constructor(element) {
    this.deferred = new $.Deferred()
    this.headerElement = $('.header')
    this.importantNoticeElement = $('#important_notices_header')
    this.element = element

    this.scene = new Scene(this)
    this.leafletView = new LeafletView(this)
    this.leafletNavigationView = new LeafletNavigationView(this)
    this.assignEvent()
    this.initialize()
  }

  initialize() {
    this.scene.setSize()
    this.element.find('.indicator').show()
    return this.deferred.promise().then(() => {
      this.render()
      this.scene.setSize()
      this.element.find('.indicator').hide()
      return this.scene.justify()
    })
  }

  render(animate = false) {
    this.leafletView.render(animate)
    return this.leafletNavigationView.render()
  }

  changeLeaflet(leafletObject) {
    this.deferred = new $.Deferred()
    this.initialize()
    this.leafletNavigationView.changeLeaflet(leafletObject)
    return this.leafletView.changeLeaflet(leafletObject)
  }

  setSize() {
    this.element.width(this.scene.width)
    return this.element.height(this.scene.height)
  }

  resolveLocation(e) {
    if (e.clientX && e.clientY) {
      return { x: e.clientX, y: e.clientY }
    } else if (e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0]) {
      const touch = e.originalEvent.touches[0]
      return { x: touch.clientX, y: touch.clientY }
    } else {
      return { x: 0, y: 0 }
    }
  }

  pitchTouches(t1, t2) {
    return Math.sqrt(Math.pow(t2.pageX - t1.pageX, 2) + Math.pow(t2.pageY - t1.pageY, 2))
  }

  assignEvent() {
    this.dragging = false
    this.element
      .on('dblclick', (e) => {
        const loc = this.resolveLocation(e)
        return this.scene.magnify(loc.x, loc.y)
      })
      .on('mousedown touchstart', (e) => {
        e.preventDefault()
        this.dragging = true
        const loc = this.resolveLocation(e)
        return this.scene.startMove(loc.x, loc.y)
      })
      .on('mousemove', (e) => {
        e.preventDefault()
        if (!this.dragging) {
          return
        }
        const loc = this.resolveLocation(e)
        return this.scene.move(loc.x, loc.y)
      })
      .on('DOMMouseScroll mousewheel', (e) => {
        e.preventDefault()
        const x = e.clientX || e.originalEvent.clientX
        const y = e.clientY || e.originalEvent.clientY
        if (e.originalEvent.detail > 0 || e.originalEvent.wheelDelta < 0) {
          return this.scene.smoothMinify(x, y)
        } else {
          return this.scene.smoothMagnify(x, y)
        }
      })
      .data('dblTap', false)
      .on('touchend', (e) => {
        // for Touch Device double tap(double click)
        if (this.lastTouches > 1) {
          return
        } // if last touches greater than 1, it's pinching

        if (this.timer) {
          clearTimeout(this.timer)
        }
        const target = $(e.currentTarget)
        if (target.data('dblTap')) {
          this.scene.magnify(this.lastTouch.x, this.lastTouch.y)
          return target.data('dblTap', false)
        } else {
          target.data('dblTap', true)
          return (this.timer = setTimeout(() => {
            return target.data('dblTap', false)
          }, 250))
        } // to adjust double tap interval, change here
      })
      .on('touchstart', (e) => {
        e.preventDefault()
        const touches = e.originalEvent.targetTouches
        this.lastTouches = touches.length
        this.lastTouchesPitch = 0
        if (touches.length > 1) {
          // two fingers(more than one finger)
          this.dragging = false
          this.lastTouchesPitch = this.pitchTouches(touches[0], touches[1])
          return (this.lastTouch = { x: 0, y: 0 })
        } else {
          this.dragging = true
          return (this.lastTouch = {
            x: touches[0].pageX,
            y: touches[0].pageY,
          })
        }
      })
      .on('touchmove', (e) => {
        e.preventDefault()
        const touches = e.originalEvent.targetTouches
        const x = touches[0].pageX
        const y = touches[0].pageY
        if (touches.length > 1) {
          // two fingers(more than one finger)
          this.dragging = false
          const pitch = this.pitchTouches(touches[0], touches[1])
          if (pitch > this.lastTouchesPitch) {
            this.scene.smoothMagnify(x, y)
          } else {
            this.scene.smoothMinify(x, y)
          }
          return (this.lastTouchesPitch = pitch)
        } else if (this.dragging) {
          // prevent malfunction after pinching
          return this.scene.move(x, y)
        }
      })

    $(window)
      .on('mouseup', (e) => {
        e.preventDefault()
        return (this.dragging = false)
      })
      .on('contextmenu', (e) => {
        // NOTE: Mouse releasing with context menu click does not triggers mouseup.
        // We prevent contextmenu event to fix https://ghe.ckpd.co/tech/bargain/issues/1346
        return e.preventDefault()
      })

    return $(window).on(
      'resize orientationchange shopmagazineformshow shopmagazineformhide importantnoticehide',
      () => {
        this.scene.setSize()
        return this.render()
      }
    )
  }
}

export default SceneView;
